import { render, staticRenderFns } from "./installer-install-orders.vue?vue&type=template&id=0b5925de&scoped=true"
import script from "./installer-install-orders.vue?vue&type=script&lang=js"
export * from "./installer-install-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5925de",
  null
  
)

export default component.exports